import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M17.7188 19.2424C18.1093 19.6329 18.7425 19.6329 19.133 19.2424C19.5235 18.8518 19.5235 18.2187 19.133 17.8282L13.2406 11.9358L19.1331 6.0433C19.5237 5.65278 19.5237 5.01961 19.1331 4.62909C18.7426 4.23857 18.1095 4.23857 17.7189 4.62909L11.8264 10.5216L5.93367 4.62883C5.54315 4.23831 4.90998 4.23831 4.51946 4.62883C4.12893 5.01935 4.12893 5.65252 4.51946 6.04304L10.4122 11.9358L4.51961 17.8284C4.12908 18.2189 4.12908 18.8521 4.51961 19.2426C4.91013 19.6332 5.5433 19.6332 5.93382 19.2426L11.8264 13.35L17.7188 19.2424Z" })]
});
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
